import React from "react";
import { connect } from "react-redux";
import { withLocalize } from "react-localize-redux";
import PropTypes from "prop-types";
import servicesImg from "../../Assets/Images/services_all_in_one_img.svg";
import "./styles.scss";
import "../BookingFlowForMarketplace/CheckoutStep/Assets/Styles/index.css";
import FAQ from "./FAQ";
import {
  soothe_pass_subscriptions,
  createSoothePassSubscription,
  getClient,
} from "../Shared/Helpers";
import { get, map, isEmpty, forEach, filter } from "lodash";
import { setSoothePassSubscriptions } from "../../Actions";
import { loadClient } from "../../Actions/ClientAction";
import UserAvatar from "../../Assets/Images/placeholder.png";
import SunburstFrame from "../../Assets/Images/sunburst_frame.png";
import LatestModalDesign from "../Shared/LatestModalDesign";
import PaymentMethodList from "../PaymentMethods/PaymentMethodList";
import LoadingOverlay from "../Shared/LoadingOverlay";
import CTAButton from "../Shared/CTAButton";
import ColumnsList from "../Shared/ColumnsList";
import TextWithIcon from "../Shared/TextWithIcon";
import { Elements } from "react-stripe-elements";
import { Close, InfoOutlined } from "@material-ui/icons";
import { ACTIVE_LANGUAGE_CODE, DE, US, isEventBooking } from "../../constants";
import CardIcon from "../BookingFlowForMarketplace/CheckoutStep/Assets/Images/Card_icon.png";
import Visa from "../../Assets/Images/Visa.svg";
import Master from "../../Assets/Images/Mastercard.svg";
import Discover from "../../Assets/Images/Discover.svg";
import appleIcon from "../../Assets/Images/apple.svg";
import paymentMethodIcon from "../../Assets/Images/payment-method-icon.svg";
import CreditCard from "../../Assets/Images/credit_card.svg";

class AccessSPTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1, // 1: Intro, 2: Zip, 3: Plans, 4: Checkout, 5: Confirmation
      zip: "",
      showErrorModal: false,
      error: null,
      showPaymentModal: false,
      selectedPaymentMethod: null,
      isCreatingSubscription: false,
      isChecked: false,
      width: window.innerWidth,
    };
  }
  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth });
  }
  componentDidMount() {
    window.addEventListener('resize', this.updateWindowDimensions);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  errorHandler = (error) => {
    this.setState({ showErrorModal: true, error });
  };

  closeErrorModal = () => {
    this.setState({ showErrorModal: false, error: null });
  };

  handleNext = () => {
    const { step } = this.state;
    if (step === 2 && !this.state.zip) return;
    if (step === 2 && this.state.zip) {
      return soothe_pass_subscriptions(
        { zip_code: this.state.zip },
        (response) => {
          const { subscription_tiers } = response.data;
          // TODO need a loading state
          this.props.setSoothePassSubscriptions({ subscription_tiers });
          this.setState({ step: step + 1 });
        },
        (error) => {
          this.errorHandler(
            get(
              error,
              "response.data.errors.0.message",
              "Failed to get subscription tiers"
            )
          );
        }
      );
    }
    this.setState({ step: step + 1 });
  };

  handleBack = () => {
    const { step } = this.state;
    if (step > 1) this.setState({ step: step - 1 });
  };

  handleZipChange = (e) => {
    this.setState({ zip: e.target.value });
  };

  handlePlanSelect = (index) => {
    this.setState({ selectedPlan: index });
  };

  handleChecked = () => {
    this.setState({ isChecked: !this.state.isChecked });
  };

  handlePaymentMethodSelect = (paymentMethod) => {
    this.setState({
      selectedPaymentMethod: paymentMethod,
      showPaymentModal: false,
    });
  };

  createSubscription = (paymentMethod) => {
    this.setState({ isCreatingSubscription: true });

    const { client, soothePassSubscriptions } = this.props;
    const { selectedPlan } = this.state;

    // Check if user is logged in
    const isLoggedIn = get(client, "loggedIn", false);
    if (!isLoggedIn) {
      this.setState({ isCreatingSubscription: false });
      this.errorHandler("You must be logged in to create a subscription");
      return;
    }

    const client_id = get(client, "user_id");
    const subscription_tier = get(
      soothePassSubscriptions,
      `subscription_tiers.${selectedPlan}`
    );
    const subscription_tier_id = get(subscription_tier, "plan.id");
    const city_id = get(subscription_tier, "city_id"); // Default to 2 if not available
    const credit_card_id = get(paymentMethod, "id");

    if (!client_id || !subscription_tier_id || !credit_card_id) {
      this.setState({ isCreatingSubscription: false });
      this.errorHandler(
        "Missing required information for subscription creation"
      );
      return;
    }

    const subscription = {
      city_id,
      subscription_tier_id,
      credit_card_id,
    };

    createSoothePassSubscription(
      client_id,
      subscription,
      (response) => {
        // Subscription creation successful, fetch fresh client data to get updated points
        getClient(
          (clientResponse) => {
            const freshClient = get(clientResponse, "data.client");
            // Show confirmation and store fresh client data for manual update
            this.setState({
              isCreatingSubscription: false,
              step: 5, // Go to confirmation
              freshClientData: freshClient, // Store for manual update when user closes
            });
            // Delay the client refresh to allow confirmation to show
            // setTimeout(() => {
            // if (freshClient) {
            //   this.props.loadClient({ ...freshClient, loggedIn: true });
            // }
            // }, 3000); // Show confirmation for 3 seconds before updating client
          },
          (clientError) => {
            console.error(
              "Failed to fetch fresh client data after subscription creation:",
              clientError
            );
            this.setState({
              isCreatingSubscription: false,
              step: 5,
            });
          }
        );
      },
      (error) => {
        this.setState({ isCreatingSubscription: false });
        this.errorHandler(
          get(
            error,
            "response.data.errors.0.message",
            "Failed to create subscription"
          )
        );
      }
    );
  };

  closePaymentModal = () => {
    if (!this.state.isCreatingSubscription) {
      this.setState({ showPaymentModal: false });
    }
  };

  handleCloseConfirmation = () => {
    // Update client with fresh data and go back to main screen
    if (this.state.freshClientData) {
      this.props.loadClient({ ...this.state.freshClientData, loggedIn: true });
    }
    // This will trigger the parent component to switch views
  };

  // Helper method to check if user already has active subscription
  hasActiveSubscription = () => {
    const soothePassSubscriptions = get(
      this.props,
      "client.soothe_pass_subscriptions",
      []
    );
    return soothePassSubscriptions.some((sub) => sub.status === "active");
  };

  // Card icon helper functions (from PaymentMethodList)
  getCardIcon = (type) => {
    const cardIcons = {
      visa: Visa,
      mastercard: Master,
      discover: Discover,
      applepay: appleIcon,
      default: paymentMethodIcon,
    };

    if (!type) return cardIcons.default;
    const key = type.toLowerCase();
    if (key.includes("visa")) return cardIcons.visa;
    if (key.includes("master")) return cardIcons.mastercard;
    if (key.includes("discover")) return cardIcons.discover;
    if (key.includes("apple")) return cardIcons.applepay;
    return cardIcons.default;
  };

  getCardIconClass = (type) => {
    if (!type) return "width-35 height-24 obj-fit-contain";
    const key = type.toLowerCase();
    // Discover card has different aspect ratio, needs specific sizing
    if (key.includes("discover")) return "width-35 height-12 obj-fit-contain";
    return "width-35 height-24 obj-fit-contain";
  };

  isCardExpired = (card) => {
    if (card.exp_month && card.exp_year) {
      const now = new Date();
      const currentYear = now.getFullYear();
      const currentMonth = now.getMonth() + 1; // getMonth() returns 0-11

      if (card.exp_year < currentYear) return true;
      if (card.exp_year === currentYear && card.exp_month < currentMonth)
        return true;
    }
    return false;
  };

  // Helper method to get payment method details for display (matching PaymentMethodList format)
  getPaymentMethodDetails = () => {
    const { selectedPaymentMethod } = this.state;

    if (!selectedPaymentMethod) {
      return "Select payment method";
    }

    // Regular card display
    const displayString = selectedPaymentMethod.display_string;
    const last4 = selectedPaymentMethod.last4 || "";
    const brand =
      selectedPaymentMethod.type || selectedPaymentMethod.brand || "";

    return (
      <div className="d-flex-only align-items-center">
        {/* <img
          src={this.getCardIcon(selectedPaymentMethod.type)}
          alt={brand || "card"}
          className={`${this.getCardIconClass(
            selectedPaymentMethod.type
          )} mr-12`}
        /> */}
        <div>
          <div
          >
            {displayString ||
              (last4 && brand ? `${brand} ${last4}` : "Payment Method")}
          </div>
          {selectedPaymentMethod.exp_month &&
            selectedPaymentMethod.exp_year && (
              <div
                className={`size-14-20`}
              >
                Exp. {" "}
                {selectedPaymentMethod.exp_month}/
                {selectedPaymentMethod.exp_year}
              </div>
            )}
        </div>
      </div>
    );
  };

  renderIntro() {
    return (
      <div>
        <div className="centered">
          <div className="size-40-52 contentPrimary font-weight-bold mb-32 sm-p-24-16">
            Unlock SoothePass™
          </div>
          <div className="mb-40 size-20-28 contentPrimary">
            Use points to book at least one service every month,
            <br />
            plus save up to 30% with exclusive members-only pricing.
          </div>
          <div className="mb-40">
            <img
              src={servicesImg}
              alt="center avatar"
              className="center-avatar"
            />
          </div>
          <div className="mb-40">
            <button
              type="button"
              className="btn md-cta-primary"
              onClick={() => this.handleNext()}
              style={{
                width: "343px",
                padding: "16px 20px",
                borderRadius: "30px",
                border: "none",
                fontSize: "18px",
                fontWeight: "500",
                cursor: "pointer",
              }}
            >
              Explore plans
            </button>
          </div>
        </div>
        <div className="mt-24">
          <FAQ />
        </div>
      </div>
    );
  }

  renderZipEntry() {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          width: "100%",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "24px",
            width: "782px",
            maxWidth: "90%",
            padding: "0 20px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "24px",
              padding: "0 0 16px",
              textAlign: "center",
            }}
          >
            <div
              className="size-40-52 contentPrimary font-weight-bold"
              style={{ fontSize: "40px", lineHeight: "1.3em" }}
            >
              Enter your zip code
            </div>
            <div
              className="size-20-28 contentPrimary font-weight-medium"
              style={{ fontSize: "20px", lineHeight: "1.4em" }}
            >
              Your zip code helps us determine if SoothePass is available in
              your area.
            </div>
          </div>
          <form
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "40px",
              alignItems: "center",
              width: "100%",
            }}
            onSubmit={(e) => {
              e.preventDefault();
              this.handleNext();
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                width: "375px",
                maxWidth: "100%",
                padding: "0 16px",
                alignItems: "center",
              }}
            >
              <input
                className="form-control generic-input-style-white size-18-28"
                value={this.state.zip || ""}
                onChange={(event) => this.handleZipChange(event)}
                placeholder="Enter your zip code"
                style={{
                  borderRadius: "1000px",
                  height: "56px",
                  border: "none",
                  padding: "14px 16px",
                  textAlign: "left",
                  fontSize: "18px",
                  lineHeight: "1.5555555555555556em",
                  width: "100%",
                  backgroundColor: "#FFFFFF",
                }}
              />
              <button
                type="submit"
                variant="contained"
                color="primary"
                className="btn md-cta-primary"
                disabled={!this.state.zip}
                style={{
                  width: "343px",
                  borderRadius: "30px",
                  backgroundColor: !this.state.zip ? "#CBCBCB" : "#F58266",
                  color: "#FFFFFF",
                  fontSize: "18px",
                  fontWeight: "500",
                  padding: "16px 20px",
                  height: "auto",
                  border: "none",
                  cursor: !this.state.zip ? "not-allowed" : "pointer",
                }}
              >
                Next
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }

  renderSubscriptionPlans() {
    const { subscription_tiers } = this.props.soothePassSubscriptions;
    const { width } = this.state;
    const selectedPlan =
      this.state.selectedPlan !== undefined
        ? subscription_tiers[this.state.selectedPlan]
        : null;

    // Prepare addon content based on selected plan
    let addonContent = null;
    if (selectedPlan) {
      const planName = get(selectedPlan, "plan.name", "");
      const points = get(selectedPlan, "points", "");
      const price = get(selectedPlan, "price.value", "");

      addonContent = {
        direction: "left",
        content: `${planName} plan, ${points} points`,
        subContent: `${price}.00/month`,
      };
    }

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          width: "100%",
          overflow: "hidden",
          position: "relative",
          padding: "0 clamp(16px, 8vw, 112px)", // Responsive padding
          paddingBottom: "120px", // Account for fixed bottom section
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "clamp(16px, 3vh, 32px)", // Responsive gap
            width: "830px",
            maxWidth: "90%",
            height: "100%",
            justifyContent: "center",
          }}
        >
          {/* Title */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              padding: "0 0 8px",
              textAlign: "center",
              flexShrink: 0, // Prevent title from shrinking
            }}
          >
            <div
              style={{
                fontFamily: "Poppins",
                fontWeight: "500",
                fontSize: "40px",
                lineHeight: "1.3em",
                color: "#000000",
              }}
            >
              Choose your plan
            </div>
          </div>

          {/* Plans Container */}
          <div
            style={{
              display: "flex",
              gap: "16px",
              alignItems: "stretch",
              flex: "1",
              maxHeight: "400px", // Prevent cards from getting too tall
              flexDirection: width >= 800 ? 'row' : 'column',
            }}
          >
            {map(subscription_tiers, (subscription_tier, idx) => (
              <div
                key={idx}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  flex: "1",
                  padding: "16px",
                  backgroundColor: "#FFFFFF",
                  borderRadius: "8px",
                  border:
                    this.state.selectedPlan === idx
                      ? "3px solid #5F637A"
                      : "none",
                  cursor: "pointer",
                  boxSizing: "border-box",
                  height: "100%", // Use full available height instead of minHeight
                }}
                onClick={() => this.setState({ selectedPlan: idx })}
              >
                {/* Content frame */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignSelf: "stretch",
                    height: "100%",
                  }}
                >
                  {/* Text frame */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignSelf: "stretch",
                      gap: "16px",
                      flex: "1",
                    }}
                  >
                    {/* Content leading */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignSelf: "stretch",
                        gap: "4px",
                      }}
                    >
                      {/* Plan name */}
                      <div
                        style={{
                          fontFamily: "Poppins",
                          fontWeight: "500",
                          fontSize: "14px",
                          lineHeight: "1.1428571428571428em",
                          color: "#757575",
                          textAlign: "left",
                        }}
                      >
                        {get(subscription_tier, "plan.name")}
                      </div>

                      {/* Points */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignSelf: "stretch",
                          height: "32px",
                          justifyContent: "center",
                        }}
                      >
                        <div
                          style={{
                            fontFamily: "Poppins",
                            fontWeight: "500",
                            fontSize: "22px",
                            lineHeight: "1.3636363636363635em",
                            color: "#000000",
                            textAlign: "left",
                          }}
                        >
                          {subscription_tier.points} points
                        </div>
                      </div>
                    </div>

                    {/* Description */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignSelf: "stretch",
                        flex: "1",
                      }}
                    >
                      <div
                        style={{
                          fontFamily: "Poppins",
                          fontWeight: "400",
                          fontSize: "14px",
                          lineHeight: "1.4285714285714286em",
                          color: "#545454",
                          textAlign: "left",
                        }}
                      >
                        {get(subscription_tier, "plan.description")}
                      </div>
                    </div>

                    {/* Price section */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-end",
                        alignSelf: "stretch",
                        gap: "16px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          marginLeft: "auto",
                        }}
                      >
                        <div
                          style={{
                            fontFamily: "Poppins",
                            fontWeight: "500",
                            fontSize: "20px",
                            lineHeight: "1.4em",
                            color: "#000000",
                            textAlign: "right",
                          }}
                        >
                          {get(subscription_tier, "price.value")}.00
                        </div>
                        <div
                          style={{
                            fontFamily: "Poppins",
                            fontWeight: "400",
                            fontSize: "12px",
                            lineHeight: "1.6666666666666667em",
                            color: "#545454",
                            textAlign: "right",
                          }}
                        >
                          {get(subscription_tier, "price.per_period_brief")}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom CTA Button Section */}
        <div
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: "#FFFFFF",
            borderTop: "1px solid #E2E2E2",
            padding: "16px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
            }}
          >
            {/* Addon Content - Left Side */}
            {addonContent && (
              <div
                style={{
                  flex: 1,
                  textAlign: "right",
                }}
              >
                <div
                  style={{
                    fontFamily: "Poppins",
                    fontWeight: "500",
                    fontSize: "16px",
                    lineHeight: "1.25em",
                    color: "#000000",
                    marginBottom: "4px",
                  }}
                >
                  {addonContent.content}
                </div>
                <div
                  style={{
                    fontFamily: "Poppins",
                    fontWeight: "400",
                    fontSize: "14px",
                    lineHeight: "1.4285714285714286em",
                    color: "#545454",
                  }}
                >
                  {addonContent.subContent}
                </div>
              </div>
            )}

            {/* Button - Right Side */}
            <button
              type="button"
              className="btn"
              disabled={this.state.selectedPlan === undefined}
              onClick={() => this.handleNext()}
              style={{
                width: "194px",
                padding: "16px 20px",
                backgroundColor:
                  this.state.selectedPlan !== undefined ? "#F58266" : "#F6F6F6",
                color:
                  this.state.selectedPlan !== undefined ? "#FFFFFF" : "#757575",
                borderRadius: "30px",
                border: "none",
                fontFamily: "Poppins",
                fontWeight: "500",
                fontSize: "18px",
                lineHeight: "1.3333333333333333em",
                textAlign: "center",
                cursor:
                  this.state.selectedPlan !== undefined
                    ? "pointer"
                    : "not-allowed",
              }}
            >
              Go to Checkout
            </button>
          </div>
        </div>
      </div>
    );
  }
  // Helper function to convert newlines to <br/> tags
  formatTitleWithLineBreaks = (title) => {
    if (!title) return title;
    
    return title.split('\n').map((line, index, array) => (
      <span key={index}>
        {line}
        {index < array.length - 1 && <br />}
      </span>
    ));
  };

  renderBillingLineItems(planData = null) {
    const arr = [];

    // Handle plan line_items if provided
    if (planData && !isEmpty(planData.line_items)) {
      const filteredLineItems = filter(
        planData.line_items,
        (item) => item.title !== "Subtotal" && !item.amount.startsWith("-") 
      );
      forEach(filteredLineItems, (item) => {
        let price;
        const strikedThroughText = item.strike_through_text ? (
          <span className="gray-strike-through">
            {item.strike_through_text}
          </span>
        ) : null;

        // Handle negative amounts (discounts) with green color
        if (`${item.amount}`.startsWith("-")) {
          price = <span className="color-green">{item.amount}</span>;
        } else {
          price = (
            <span>
              {strikedThroughText}
              {strikedThroughText ? " " : ""}
              {item.amount}
            </span>
          );
        }

        let additionalTag = null;
        if (item.tooltip_title) {
          let { tooltip_title, tooltip_text, tooltip_text_links } = item;

          let temp = null;
          if (isEmpty(tooltip_text_links)) {
            temp = tooltip_text;
          } else {
            map(tooltip_text_links, (item2) => {
              const { text, link } = item2;
              let splittedArr = tooltip_text.split(text);
              if (!temp) {
                temp = splittedArr[0];
              }
              let part2 = splittedArr[1];
              temp = (
                <>
                  {temp}{" "}
                  {
                    <a
                      className="underline BluePrimary"
                      href={link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {text}
                    </a>
                  }
                  {part2}
                </>
              );
            });
          }
          additionalTag = (
            <InfoOutlined
              className="contentSecondary cursor-pointer w-h-20 ml-6"
              onClick={() => {
                this.setState({
                  tooltip: {
                    title: tooltip_title,
                    subtitle: temp,
                  },
                });
              }}
            />
          );
        }

        // Handle plan line_items with subtitle
        if (item.subtitle) {
          arr.push({
            text: (
              <>
                {this.formatTitleWithLineBreaks(item.title)} {additionalTag}
              </>
            ),
            price,
          });
          arr.push({
            text: (
              <div
                className="size-12-20 clr-light-gray"
                style={{ marginLeft: "16px" }}
              >
                {item.subtitle}
              </div>
            ),
          });
        } else {
          arr.push({
            text: (
              <>
                {this.formatTitleWithLineBreaks(item.title)} {additionalTag}
              </>
            ),
            price,
          });
        }
      });

      return arr;
    }

    // Fallback to existing booking cart billing logic
    const billing = get(this.props, "booking.cart.billing", null);
    if (!isEmpty(billing)) {
      let { top_billing_line_items } = billing;

      if (isEventBooking() && this.props.isReviewStep) {
        top_billing_line_items = filter(
          top_billing_line_items,
          (el) => el.title !== "Tip"
        );
      }

      if (!isEmpty(top_billing_line_items)) {
        forEach(top_billing_line_items, (item) => {
          let price;
          const strikedThroughText = item.strike_through_text ? (
            <span className="gray-strike-through">
              {item.strike_through_text}
            </span>
          ) : null;
          if (`${item.amount}`.startsWith("-")) {
            price = <span className="color-green">{item.amount}</span>;
          } else {
            price = (
              <span>
                {strikedThroughText} {item.amount}
              </span>
            );
          }
          let additionalTag = null;
          if (item.tooltip_title) {
            let { tooltip_title, tooltip_text, tooltip_text_links } = item;

            let temp = null;
            if (isEmpty(tooltip_text_links)) {
              temp = tooltip_text;
            } else {
              map(tooltip_text_links, (item2) => {
                // note: order of links matter
                const { text, link } = item2;
                let splittedArr = tooltip_text.split(text);
                if (!temp) {
                  temp = splittedArr[0];
                }
                let part2 = splittedArr[1];
                temp = (
                  <>
                    {temp}{" "}
                    {
                      <a
                        className="underline BluePrimary"
                        href={link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {text}
                      </a>
                    }
                    {part2}
                  </>
                );
              });
            }
            additionalTag = (
              <InfoOutlined
                className="contentSecondary cursor-pointer w-h-20 ml-6"
                onClick={() => {
                  this.setState({
                    tooltip: {
                      title: tooltip_title,
                      subtitle: temp,
                    },
                  });
                }}
              />
            );
          }

          if (!isEmpty(item.subtitles)) {
            forEach(item.subtitles, (subtitle, ind) => {
              if (ind === 0) {
             arr.push({
               text: (
                 <div className="d-flex-only align-items-center">
                   <span className="contentPrimary medium-font">
                     {this.formatTitleWithLineBreaks(item.title)}
                   </span>{" "}
                   {additionalTag}
                 </div>
               ),
             });
                arr.push({ text: subtitle, price });
              } else {
                arr.push({ text: "- " + subtitle });
              }
            });
          } else if (item.subtitle) {
            // Check if this is a SoothePass related subtitle
            const isSoothePassSubtitle =
              item.title && item.title.toLowerCase().includes("soothepass");
            const marginLeft = isSoothePassSubtitle ? "32px" : "16px";

             arr.push({
               text: (
                 <>
                   {this.formatTitleWithLineBreaks(item.title)} {additionalTag}
                 </>
               ),
               price,
             });
            arr.push({
              text: (
                <div
                  className="size-12-20 clr-light-gray"
                  style={{ marginLeft }}
                >
                  {item.subtitle}
                </div>
              ),
            });
           } else {
             arr.push({
               text: (
                 <>
                   {this.formatTitleWithLineBreaks(item.title)} {additionalTag}
                 </>
               ),
               price,
             });
           }
        });
      }
    }
    return arr;
  }
  renderSecondBillingLineItems(planData = null) {
    const arr = [];

    // Handle plan line_items if provided
    if (planData && !isEmpty(planData.line_items)) {
      const filteredLineItems = filter(
        planData.line_items,
        (item) => item.title === "Subtotal" || item.amount.startsWith("-") 
      );
      forEach(filteredLineItems, (item) => {
        let price;
        const strikedThroughText = item.strike_through_text ? (
          <span className="gray-strike-through">
            {item.strike_through_text}
          </span>
        ) : null;

        // Handle negative amounts (discounts) with green color
        if (`${item.amount}`.startsWith("-")) {
          price = <span className="color-green">{item.amount}</span>;
        } else {
          price = (
            <span>
              {strikedThroughText}
              {strikedThroughText ? " " : ""}
              {item.amount}
            </span>
          );
        }

        let additionalTag = null;
        if (item.tooltip_title) {
          let { tooltip_title, tooltip_text, tooltip_text_links } = item;

          let temp = null;
          if (isEmpty(tooltip_text_links)) {
            temp = tooltip_text;
          } else {
            map(tooltip_text_links, (item2) => {
              const { text, link } = item2;
              let splittedArr = tooltip_text.split(text);
              if (!temp) {
                temp = splittedArr[0];
              }
              let part2 = splittedArr[1];
              temp = (
                <>
                  {temp}{" "}
                  {
                    <a
                      className="underline BluePrimary"
                      href={link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {text}
                    </a>
                  }
                  {part2}
                </>
              );
            });
          }
          additionalTag = (
            <InfoOutlined
              className="contentSecondary cursor-pointer w-h-20 ml-6"
              onClick={() => {
                this.setState({
                  tooltip: {
                    title: tooltip_title,
                    subtitle: temp,
                  },
                });
              }}
            />
          );
        }

        // Handle plan line_items with subtitle
        if (item.subtitle) {
          arr.push({
            text: (
              <>
                {this.formatTitleWithLineBreaks(item.title)} {additionalTag}
              </>
            ),
            price,
          });
          arr.push({
            text: (
              <div
                className="size-12-20 clr-light-gray"
                style={{ marginLeft: "16px" }}
              >
                {item.subtitle}
              </div>
            ),
          });
        } else {
          arr.push({
            text: (
              <>
                {this.formatTitleWithLineBreaks(item.title)} {additionalTag}
              </>
            ),
            price,
          });
        }
      });

      return arr;
    }

    // Fallback to existing booking cart billing logic
    const billing = get(this.props, "booking.cart.billing", null);
    if (!isEmpty(billing)) {
      let { top_billing_line_items } = billing;

      if (isEventBooking() && this.props.isReviewStep) {
        top_billing_line_items = filter(
          top_billing_line_items,
          (el) => el.title !== "Tip"
        );
      }

      if (!isEmpty(top_billing_line_items)) {
        forEach(top_billing_line_items, (item) => {
          let price;
          const strikedThroughText = item.strike_through_text ? (
            <span className="gray-strike-through">
              {item.strike_through_text}
            </span>
          ) : null;
          if (`${item.amount}`.startsWith("-")) {
            price = <span className="color-green">{item.amount}</span>;
          } else {
            price = (
              <span>
                {strikedThroughText} {item.amount}
              </span>
            );
          }
          let additionalTag = null;
          if (item.tooltip_title) {
            let { tooltip_title, tooltip_text, tooltip_text_links } = item;

            let temp = null;
            if (isEmpty(tooltip_text_links)) {
              temp = tooltip_text;
            } else {
              map(tooltip_text_links, (item2) => {
                // note: order of links matter
                const { text, link } = item2;
                let splittedArr = tooltip_text.split(text);
                if (!temp) {
                  temp = splittedArr[0];
                }
                let part2 = splittedArr[1];
                temp = (
                  <>
                    {temp}{" "}
                    {
                      <a
                        className="underline BluePrimary"
                        href={link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {text}
                      </a>
                    }
                    {part2}
                  </>
                );
              });
            }
            additionalTag = (
              <InfoOutlined
                className="contentSecondary cursor-pointer w-h-20 ml-6"
                onClick={() => {
                  this.setState({
                    tooltip: {
                      title: tooltip_title,
                      subtitle: temp,
                    },
                  });
                }}
              />
            );
          }

          if (!isEmpty(item.subtitles)) {
            forEach(item.subtitles, (subtitle, ind) => {
              if (ind === 0) {
             arr.push({
               text: (
                 <div className="d-flex-only align-items-center">
                   <span className="contentPrimary medium-font">
                     {this.formatTitleWithLineBreaks(item.title)}
                   </span>{" "}
                   {additionalTag}
                 </div>
               ),
             });
                arr.push({ text: subtitle, price });
              } else {
                arr.push({ text: "- " + subtitle });
              }
            });
          } else if (item.subtitle) {
            // Check if this is a SoothePass related subtitle
            const isSoothePassSubtitle =
              item.title && item.title.toLowerCase().includes("soothepass");
            const marginLeft = isSoothePassSubtitle ? "32px" : "16px";

             arr.push({
               text: (
                 <>
                   {this.formatTitleWithLineBreaks(item.title)} {additionalTag}
                 </>
               ),
               price,
             });
            arr.push({
              text: (
                <div
                  className="size-12-20 clr-light-gray"
                  style={{ marginLeft }}
                >
                  {item.subtitle}
                </div>
              ),
            });
           } else {
             arr.push({
               text: (
                 <>
                   {this.formatTitleWithLineBreaks(item.title)} {additionalTag}
                 </>
               ),
               price,
             });
           }
        });
      }
    }
    return arr;
  }
  renderTermsAndConditions(planData = null) {
    const { terms = "", terms_text_links = [] } = get(planData, "plan", {});

    if (!terms && isEmpty(terms_text_links)) {
      return null;
    }

    // Process the terms text to replace link text with actual links
    let processedTerms = terms;
    let linkElements = [];

    if (!isEmpty(terms_text_links)) {
      terms_text_links.forEach((linkData, index) => {
        const { text, link } = linkData;
        const linkElement = (
          <a
            key={index}
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="underline BluePrimary"
          >
            {text}
          </a>
        );

        // Replace the text in the terms with a placeholder
        const placeholder = `__LINK_${index}__`;
        processedTerms = processedTerms.replace(text, placeholder);
        linkElements.push({ placeholder, element: linkElement });
      });
    }

    // Split the processed terms by placeholders and insert link elements
    const termsParts = processedTerms.split(/(__LINK_\d+__)/);
    const finalTerms = termsParts.map((part, index) => {
      const linkMatch = linkElements.find((le) => le.placeholder === part);
      return linkMatch ? linkMatch.element : part;
    });

    return (
      <div className="terms-section">
        <div className="terms-container">
          <div className="terms-checkbox-container">
            <input
              type="checkbox"
              id="terms-checkbox"
              checked={this.state.isChecked}
              onChange={this.handleChecked}
              className="terms-checkbox"
            />
            <label htmlFor="terms-checkbox" className="terms-text">
              {finalTerms}
            </label>
          </div>
        </div>
      </div>
    );
  }

  renderCheckout() {
    const { subscription_tiers } = this.props.soothePassSubscriptions;
    const selectedPlan =
      this.state.selectedPlan !== undefined
        ? subscription_tiers[this.state.selectedPlan]
        : null;

    if (!selectedPlan) {
      return <div>No plan selected</div>;
    }

    const price = get(selectedPlan, "price.value", "");

    return (
      <>
        <div className="mb-106 sm-mb-254 mt-80 sm-mt-0-imp">
          <div className="max-width-55 sm-max-width-100">
            <div className="size-44-52 sm-size-28-36 contentPrimary medium-font txt-center sm-txt-left mb-24 sm-mb-12">
              Checkout
            </div>

            <div className="background-primary border-radius-16 p-16-32 sm-border-radius-0">
              <div>
                {/* Order Summary */}
                <div className="br-btm-gray">
                  <div className="second-title-style font-weight-bold">Order Summary</div>
                  <div className="br-btm-gray-thin">
                    <ColumnsList
                      itemsList={this.renderBillingLineItems(selectedPlan)}
                    />
                  </div>
                  <div className="br-btm-gray-thin">
                    <ColumnsList
                      itemsList={this.renderSecondBillingLineItems(selectedPlan)}
                    />
                  </div>
                  <ColumnsList
                    headerText={<div className="font-weight-bold">Today's total</div>}
                    headerPrice={`${price}${get(
                      selectedPlan,
                      "price.per_period_brief",
                      ""
                    )}`}
                  />
                </div>

                {/* Payment Method Section */}
                <div className="br-btm-gray">
                  <div className="clickable" onClick={() => this.setState({ showPaymentModal: true })}>
                  <TextWithIcon
                    icon={CreditCard}
                    title={<div className="font-weight-bold">Payment Method</div>}
                    details={this.getPaymentMethodDetails()}
                    displayArrow
                  />
                  </div>
                </div>

                {/* Terms and Conditions */}
                {this.renderTermsAndConditions(selectedPlan)}
              </div>
              <div className="d-flex-only justify-content-center p-16">
               <button
                 disabled={
                   !this.state.selectedPaymentMethod || !this.state.isChecked || this.state.isCreatingSubscription}
                 onClick={() => {
                   if (
                     this.state.selectedPaymentMethod &&
                     this.state.isChecked &&
                     !this.state.isCreatingSubscription
                   ) {
                     this.createSubscription(this.state.selectedPaymentMethod);
                   }
                 }}
                 style={{
                  width: "100%",
                  maxWidth: "343px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "10px",
                  padding: "16px 20px",
                  backgroundColor:
                  this.state.selectedPaymentMethod &&
                  !this.state.isCreatingSubscription &&
                  this.state.isChecked
                    ? "#F58266"
                    : "#F6F6F6",
                  color:
                  this.state.selectedPaymentMethod &&
                  !this.state.isCreatingSubscription &&
                  this.state.isChecked
                    ? "#FFFFFF"
                    : "#757575",
                  fontSize: "18px",
                  fontWeight: "500",
                  borderRadius: "30px",
                  border: "none",
                  cursor: "pointer",}}
               >
                Subscribe
                </button>
                </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  renderConfirmation() {
    const avatar = get(this.props, "client.avatar_url", "");
    const firstName = get(this.props, "client.first_name", "");
    const { width } = this.state;
    // Get points from fresh client data or current client data
    const points = get(
      this.state,
      "freshClientData.points",
      get(this.props, "client.points", 0)
    );

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          width: "100%",
          overflow: "hidden",
          position: "relative",
        }}
      >
        {/* Close Button */}
        <div
          style={{
            position: "absolute",
            top: "32px",
            left: "32px",
            zIndex: 10,
          }}
        >
          <button
            onClick={this.handleCloseConfirmation}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "48px",
              height: "48px",
              borderRadius: "48px",
              border: "none",
              backgroundColor: "transparent",
              cursor: "pointer",
              padding: "14px",
            }}
          >
            <Close
              style={{
                fontSize: "20px",
                color: "#323232",
              }}
            />
          </button>
        </div>

        {/* Main Content */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "16px",
            width: width >= 800 ? "607px" : "100%",
            padding: width >= 800 ? "0" : "16px",
            margin: "0 auto",
            height: "100%",
          }}
        >
          {/* Welcome Message */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignSelf: "stretch",
              gap: "24px",
            }}
          >
            <div
              style={{
                fontFamily: "Poppins",
                fontWeight: "500",
                fontSize: "24px",
                lineHeight: "1.3333333333333333em",
                textAlign: "center",
                color: "#000000",
              }}
            >
              Here's to the newest
              <br />
              SoothePass™ member!
            </div>
          </div>

          {/* Avatar Section */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              alignSelf: "stretch",
              gap: "10px",
            }}
          >
            <div
              style={{
                position: "relative",
                width: "325px",
                height: "296px",
              }}
            >
              <img
                src={SunburstFrame}
                alt="sunburst frame"
                style={{
                  position: "absolute",
                  top: "0",
                  left: "0",
                  width: "325px",
                  height: "296px",
                }}
              />
              <img
                src={avatar || UserAvatar}
                alt="user avatar"
                style={{
                  position: "absolute",
                  top: "91px",
                  left: "105px",
                  width: "115px",
                  height: "115px",
                  borderRadius: "50%",
                  border: "1px solid #E2E2E2",
                }}
              />
            </div>
          </div>

          {/* Points Section */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignSelf: "stretch",
              gap: "32px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignSelf: "stretch",
                gap: "4px",
              }}
            >
              <div
                style={{
                  fontFamily: "Poppins",
                  fontWeight: "500",
                  fontSize: "24px",
                  lineHeight: "1.3333333333333333em",
                  textAlign: "center",
                  color: "#000000",
                }}
              >
                You've got
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignSelf: "stretch",
                  gap: "24px",
                }}
              >
                <div
                  style={{
                    fontFamily: "Poppins",
                    fontWeight: "500",
                    fontSize: "40px",
                    lineHeight: "1.3em",
                    textAlign: "center",
                    color: "#000000",
                  }}
                >
                  {points} points
                </div>
              </div>
            </div>

            <div
              style={{
                fontFamily: "Poppins",
                fontWeight: "500",
                fontSize: "18px",
                lineHeight: "1.3333333333333333em",
                textAlign: "center",
                color: "#757575",
              }}
            >
              That's enough to cover a 60 minute massage!
              <br />
              What are you waiting for?
            </div>

            {/* Button Container */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignSelf: "stretch",
                gap: "16px",
                padding: "24px 0 0",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  alignSelf: "stretch",
                  padding: "0 16px",
                }}
              >
                <button
                  onClick={() => {
                    window.location.href = "/booking/";
                  }}
                  style={{
                    width: "343px",
                    padding: "16px 20px",
                    borderRadius: "30px",
                    border: "none",
                    backgroundColor: "#F58266",
                    color: "#FFFFFF",
                    fontFamily: "Poppins",
                    fontWeight: "500",
                    fontSize: "18px",
                    lineHeight: "1.3333333333333333em",
                    textAlign: "center",
                    cursor: "pointer",
                  }}
                >
                  Use my points now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderPaymentMethodModal() {
    const countryCode = ACTIVE_LANGUAGE_CODE === DE ? DE : US;
    const fonts = [
      {
        src: 'url("https://www.soothe.com/static/media/GothamHTF-Book.48680770.otf")',
        family: "gotham",
      },
    ];

    return (
      <LatestModalDesign
        isOpen={this.state.showPaymentModal}
        title="Add Payment Method"
        close={
          this.state.isCreatingSubscription ? null : this.closePaymentModal
        }
        apply={() => {
          if (this.state.selectedPaymentMethod) {
            this.handlePaymentMethodSelect(this.state.selectedPaymentMethod);
          }
        }}
        applyBtnCopy={
          this.state.isCreatingSubscription ? "Creating..." : "Continue"
        }
        cancelBtnCopy="Cancel"
        disabled={
          !this.state.selectedPaymentMethod || this.state.isCreatingSubscription
        }
        style={{
          maxWidth: "600px",
          width: "90%",
        }}
      >
        <div style={{ padding: "16px" }}>
          <div className="size-16-24 contentSecondary mb-24">
            Select or add a payment method to continue with your SoothePass
            subscription.
          </div>
          <Elements locale={countryCode} fonts={fonts}>
            <PaymentMethodList
              onSelect={(method) =>
                this.setState({ selectedPaymentMethod: method })
              }
              showAdd={true}
              showDelete={false}
              showDefault={true}
            />
          </Elements>
          {this.state.isCreatingSubscription && (
            <div className="txt-center mt-24">
              <div className="size-14-20 contentSecondary">
                Creating your subscription...
              </div>
            </div>
          )}
        </div>
      </LatestModalDesign>
    );
  }

  renderErrorModal() {
    return (
      <LatestModalDesign
        isOpen={this.state.showErrorModal}
        title="Error"
        close={this.closeErrorModal}
      >
        {this.state.error}
      </LatestModalDesign>
    );
  }

  render() {
    const { step } = this.state;
    const { width } = this.state;
    return (
      <div
        className="access-sp-container"
        style={{ 
          height: "100vh", 
          overflow: width < 800 ? "hidden" : "auto" 
        }}
      >
        {step === 1 && this.renderIntro()}
        {step === 2 && this.renderZipEntry()}
        {step === 3 && this.renderSubscriptionPlans()}
        {step === 4 && this.renderCheckout()}
        {step === 5 && this.renderConfirmation()}
        {this.renderPaymentMethodModal()}
        {this.renderErrorModal()}
        <LoadingOverlay showLoader={this.state.isCreatingSubscription} />
      </div>
    );
  }
}

AccessSPTab.propTypes = {
  client: PropTypes.object,
  soothePassSubscriptions: PropTypes.object,
  setSoothePassSubscriptions: PropTypes.func,
  loadClient: PropTypes.func,
};

const mapStateToProps = (state) => ({
  client: state.client,
  soothePassSubscriptions: state.soothePassSubscriptions,
});

export default withLocalize(
  connect(mapStateToProps, { setSoothePassSubscriptions, loadClient })(
    AccessSPTab
  )
);
